module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary",
    attrs: {
      "id": "formalizacao"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Formalização"), (_vm.propsFormalizacao.ds_codigo_projeto_erp) ? _c('span', [_vm._v("  do projeto "), _c('b', [_vm._v(_vm._s(_vm.propsFormalizacao.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "cmptDocPreparationForm",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('legend', [_vm._v("Conta Impessoal (Transitória - DEB)")]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Banco")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "name": "banco",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.formalizacao.ds_agencia_banco) + " - Banco do Brasil")])])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('agencia')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|agency'),
      expression: "'required|agency'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencia",
      "mask": ['####-X'],
      "tokens": _vm.customTokens,
      "masked": true
    },
    model: {
      value: (_vm.formalizacao.ds_agencia_nome),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "ds_agencia_nome", $$v)
      },
      expression: "formalizacao.ds_agencia_nome"
    }
  }), _vm._v(" "), (_vm.errors.first('agencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('conta corrente')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Conta Corrente")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|contacorrente'),
      expression: "'required|contacorrente'"
    }],
    staticClass: "form-control",
    attrs: {
      "tokens": _vm.customTokens,
      "name": "conta corrente",
      "masked": true,
      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X']
    },
    model: {
      value: (_vm.formalizacao.ds_agencia_conta_corrente),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "ds_agencia_conta_corrente", $$v)
      },
      expression: "formalizacao.ds_agencia_conta_corrente"
    }
  }), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'required-field': _vm.propsAdiantaveis
    }
  }, [_c('legend', [_vm._v("Conta Corrente (Adiantamento)")]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Banco")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "name": "banco",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.formalizacao.ds_agencia_banco) + " - Banco do Brasil")])])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('agencia de adiantamento')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('agency'),
      expression: "'agency'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencia de adiantamento",
      "mask": ['####-X'],
      "tokens": _vm.customTokens,
      "masked": true
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificarInputContaAdiantamento($event)
      }
    },
    model: {
      value: (_vm.formalizacao.ds_agencia_adiantamento),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "ds_agencia_adiantamento", $$v)
      },
      expression: "formalizacao.ds_agencia_adiantamento"
    }
  }), _vm._v(" "), (_vm.errors.first('agencia de adiantamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('agencia de adiantamento')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('conta corrente de adiantamento')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Conta Corrente")]), _vm._v(" "), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('contacorrente'),
      expression: "'contacorrente'"
    }],
    staticClass: "form-control",
    attrs: {
      "tokens": _vm.customTokens,
      "name": "conta corrente de adiantamento",
      "masked": true,
      "mask": ['###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X']
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificarInputContaAdiantamento($event)
      }
    },
    model: {
      value: (_vm.formalizacao.ds_conta_adiantamento),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "ds_conta_adiantamento", $$v)
      },
      expression: "formalizacao.ds_conta_adiantamento"
    }
  }), _vm._v(" "), (_vm.errors.first('conta corrente de adiantamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('conta corrente de adiantamento')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("MCI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.mci),
      expression: "formalizacao.mci"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.formalizacao.mci)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao, "mci", $event.target.value)
      }, _vm.limitarDigitosMCI]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('legend', [_vm._v("Datas")]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field-field",
    class: {
      'has-error': _vm.errors.first('data proposta')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data da Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data proposta",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": false,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": _vm.validaDatas
    },
    model: {
      value: (_vm.formalizacao.dt_proposta),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "dt_proposta", $$v)
      },
      expression: "formalizacao.dt_proposta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data proposta')))]) : _vm._e()])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data análise')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de análise")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data análise",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": false,
      "placeholder": "__/__/____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": _vm.validaDatas
    },
    model: {
      value: (_vm.formalizacao.dt_analise),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "dt_analise", $$v)
      },
      expression: "formalizacao.dt_analise"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data análise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data análise')))]) : _vm._e()])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data deferimento')
    },
    attrs: {
      "uib-tooltip": "Data de deferimento"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de deferimento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data deferimento",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": false,
      "placeholder": "__/__/____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": _vm.validaDatas
    },
    model: {
      value: (_vm.propsFormalizacao.dt_deferimento),
      callback: function($$v) {
        _vm.$set(_vm.propsFormalizacao, "dt_deferimento", $$v)
      },
      expression: "propsFormalizacao.dt_deferimento"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data deferimento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data deferimento')))]) : _vm._e()])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data assinatura')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de assinatura do convênio")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data assinatura",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "use-utc": false,
      "format": "dd/MM/yyyy",
      "placeholder": "__/__/____"
    },
    on: {
      "change": _vm.datas
    },
    model: {
      value: (_vm.formalizacao.dt_assinatura_convenio),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao, "dt_assinatura_convenio", $$v)
      },
      expression: "formalizacao.dt_assinatura_convenio"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data assinatura')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data assinatura')))]) : _vm._e(), _vm._v(" "), _c('span', [_c('i', [_c('font', {
    attrs: {
      "size": "1"
    }
  }, [_vm._v("* Data de assinatura do convênio deve ser igual ou posterior a Data de deferimento")])], 1)])])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data vigência')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data de Vigência do Projeto")]), _vm._v(" "), _c('span', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.formalizacao.dt_data_vigencia, "L")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.formalizacao.hasOwnProperty('agenciaSelecionada')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Dados Complementares (Salve antes de gerar a minuta)")]), _vm._v(" "), _c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.agenciaSelecionada.agencia),
      expression: "formalizacao.agenciaSelecionada.agencia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Número da Agência"
    },
    domProps: {
      "value": (_vm.formalizacao.agenciaSelecionada.agencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao.agenciaSelecionada, "agencia", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome da Agência: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.agenciaSelecionada.nomeAgencia),
      expression: "formalizacao.agenciaSelecionada.nomeAgencia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nome da Agência"
    },
    domProps: {
      "value": (_vm.formalizacao.agenciaSelecionada.nomeAgencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao.agenciaSelecionada, "nomeAgencia", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Agência CNPJ: ")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "CNPJ da Agência",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.formalizacao.agenciaSelecionada.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao.agenciaSelecionada, "cnpj", $$v)
      },
      expression: "formalizacao.agenciaSelecionada.cnpj"
    }
  })], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome Gerente: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.nome),
      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nome do Gerente Geral"
    },
    domProps: {
      "value": (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Estado Civil Gerente: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.estadoCivil),
      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.estadoCivil"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "estadoCivil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "[ESTADO CIVIL GERENTE]"
    }
  }, [_vm._v("Estado Civil do Gerente Geral")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "solteiro"
    }
  }, [_vm._v("Solteiro(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "casado"
    }
  }, [_vm._v("Casado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "divorciado"
    }
  }, [_vm._v("Divorciado(a)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "viuvo"
    }
  }, [_vm._v("Viúvo(a)")])])])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("RG Gerente: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.rg),
      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.rg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "RG do Gerente Geral"
    },
    domProps: {
      "value": (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.rg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "rg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF Gerente: ")]), _vm._v(" "), _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "CPF do Gerente Geral",
      "mask": "###.###.###-##"
    },
    model: {
      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.cpf),
      callback: function($$v) {
        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "cpf", $$v)
      },
      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.cpf"
    }
  })], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Município Gerente: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.municipioResidencia),
      expression: "formalizacao.agenciaSelecionada.informacoesGerenteGeral.municipioResidencia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Município de Residencia do Gerente Geral"
    },
    domProps: {
      "value": (_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral.municipioResidencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao.agenciaSelecionada.informacoesGerenteGeral, "municipioResidencia", $event.target.value)
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Documentos de Deferimento")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "disable": true,
      "propDocumentos": _vm.formalizacao.documentos.deferimento,
      "documentTypes": '',
      "documentosObrigatorios": '',
      "localUso": 'PROPOSTA_DEFERIMENTO'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Documentos da Formalização")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), (!_vm._.includes(_vm.editaisComMinuta, _vm.formalizacao.fk_edital)) ? _c('div', {
    staticClass: "row-flex all-start gap-10"
  }, [_c('label', [_vm._v("Minuta para Proposta Simplificada:")]), _vm._v(" " + _vm._s(_vm.formalizacao.fk_edital) + "\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minutaSimplificada),
      expression: "minutaSimplificada"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.minutaAdicional !== ''
    },
    domProps: {
      "checked": Array.isArray(_vm.minutaSimplificada) ? _vm._i(_vm.minutaSimplificada, null) > -1 : (_vm.minutaSimplificada)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.minutaSimplificada,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.minutaSimplificada = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.minutaSimplificada = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.minutaSimplificada = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.formalizacao.fk_edital) ? _c('div', {
    staticClass: "row-flex all-start gap-10",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('label', [_vm._v("Minuta adicional (opcional):")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minutaAdicional),
      expression: "minutaAdicional"
    }],
    staticClass: "form-control respostaFav",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.minutaAdicional = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Padrão (pela regra do projeto)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "POVOS_PRIORIZADOS"
    }
  }, [_vm._v("Povos Priorizados e Dirigentes")])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.editaisComMinuta, _vm.formalizacao.fk_edital)) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                *Edital com minuta exclusiva\n              ")]) : _vm._e(), _vm._v(" "), (_vm.formalizacao.fk_edital == 9) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoMinutaEcoforte),
      expression: "tipoMinutaEcoforte"
    }],
    staticClass: "form-control respostaFav",
    attrs: {
      "disabled": _vm.minutaAdicional !== ''
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tipoMinutaEcoforte = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Edital Ecoforte: Selecione o tipo de minuta que será gerada.")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Ecoforte: BNDES (Sudeste, Sul, Centro-Oeste e Nordeste)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Ecoforte: Fundo Amazônia")])])]) : _vm._e(), _vm._v(" "), (_vm.formalizacao.fk_edital == 9) ? _c('div', [(_vm.tipoMinutaEcoforte !== '' || _vm.minutaAdicional !== '') ? _c('g-button-ujarak', {
    attrs: {
      "type": "button",
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gerarMinutaAutomatica()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Gerar Minuta")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    ref: "planoTrabalhoLink",
    staticClass: "btn btn-primary btn-sm btn-flat botao-plano",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'plano-trabalho',
        params: {
          id: _vm.$route.params.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Plano de Trabalho")])], 1) : _c('div', [_c('g-button-ujarak', {
    attrs: {
      "type": "button",
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gerarMinutaAutomatica()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Gerar Minuta")]), _vm._v(" "), _c('router-link', {
    ref: "planoTrabalhoLink",
    staticClass: "btn btn-primary btn-sm btn-flat botao-plano",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'plano-trabalho',
        params: {
          id: _vm.$route.params.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("  Plano de Trabalho")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.formalizacaoDocumentos,
      "documentTypes": _vm.tiposDocumentos,
      "documentosObrigatorios": '',
      "local-uso": 'TODOS',
      "faseProposta": _vm.propsFormalizacao.ds_fase
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" Ficha de Auto Verificação")]), _vm._v(" "), _vm._l((_vm.perguntasFAV), function(item) {
    return _c('div', [(item.nivel === 3) ? _c('label', {
      staticClass: "control-label col-md-10",
      class: 'favNivel' + item.nivel
    }, [_vm._v(_vm._s(item.numero) + " " + _vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), (item.nivel !== 3) ? _c('span', {
      staticClass: "control-label col-md-10",
      class: 'favNivel' + item.nivel
    }, [_vm._v(_vm._s(item.pergunta))]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
      }],
      staticClass: "col-md-1",
      staticStyle: {
        "alignment": "left"
      },
      attrs: {
        "title": '<h5>Pergunta <span class=\'realce\'>' + item.numero + '</span></h5>'
      }
    }, [(item.nivel === 3) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.resposta),
        expression: "item.resposta"
      }],
      staticClass: "form-control respostaFav",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "resposta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, _vm.verificarFAV]
      }
    }, _vm._l((_vm.respostaFAV), function(opcao) {
      return _c('option', {
        domProps: {
          "value": opcao.valor
        }
      }, [_vm._v(_vm._s(opcao.resposta))])
    }), 0) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('aprovacao')
    },
    attrs: {
      "uib-tooltip": "Decisões da preparação de documentos"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.resultadoAprovacao),
      expression: "formalizacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "value": "APROVAR"
    },
    domProps: {
      "checked": _vm._q(_vm.formalizacao.resultadoAprovacao, "APROVAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formalizacao, "resultadoAprovacao", "APROVAR")
      }
    }
  }), _vm._v("\n                  Formalizar o Projeto\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.resultadoAprovacao),
      expression: "formalizacao.resultadoAprovacao"
    }],
    attrs: {
      "type": "radio",
      "name": "aprovacao",
      "value": "VOLTAR_ANALISE",
      "id": "msgDef"
    },
    domProps: {
      "checked": _vm._q(_vm.formalizacao.resultadoAprovacao, "VOLTAR_ANALISE")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.formalizacao, "resultadoAprovacao", "VOLTAR_ANALISE")
      }
    }
  }), _vm._v("\n                  Devolver para Reanálise\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formalizacao.resultadoAprovacao === 'VOLTAR_ANALISE') ? _c('div', {
    staticClass: "form-group full col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formalizacao.justificativa),
      expression: "formalizacao.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa"
    },
    domProps: {
      "value": (_vm.formalizacao.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formalizacao, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block",
    staticStyle: {
      "background-color": "#e7f3ff",
      "padding": "10px",
      "border-radius": "5px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                *Antes de gerar a minuta, certifique-se de que o "), _c('b', [_vm._v("cadastro da entidade está concluído")]), _vm._v(" e que os representantes "), _c('b', [_vm._v("estejam selecionados")]), _vm._v(".\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bc1b45a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/formalizacao.vue
// module id = 1920
// module chunks = 1